<template>
    <div class="fm-container">
        <Backer />
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 10px;">Delivery Zones</div>
        <b-overlay :show="zones_being_loaded" rounded="sm">
            <div>
                <div>
                    <div v-if="zones.length > 0" v-for="zone, idx in zones" style="margin: 10px; border: 1px dashed black; padding: 5px;">
                        <div>
                            <!-- <span style="margin: 5px; width: 20px; display: inline-block;">{{zone.id}}:</span> -->
                            <div style="margin: 5px; display: inline-block;"><b-input size="sm" style="width: 200px;" v-model="zone.name" placeholder="Zone Name"></b-input>
                            </div>
                        </div>
                        <div style="margin: 5px;">
                            <b-form-textarea v-model="zones[idx].items">   
                            </b-form-textarea>
                        </div>
                        <div style="margin: 5px;">
                            <b-button size="sm" variant="warning" @click="updateZone(idx)">Save</b-button>

                            <span style="float: right; cursor: pointer;">
                                <b-badge size="sm" variant="secondary" @click="deleteZone(idx)">Delete</b-badge>
                            </span>
                        </div>
                    </div>
                </div>

                <div>
                    <b-button size="sm" variant="success" @click="addZone">Add New Zone</b-button>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"

    export default {
        name: "DeliveryZones",
        components: {Backer},
        data: function(){
            return {
                userDetails: {properties: {}},
                zones: [],
                zones_being_loaded: false,
            }
        },
        methods: {
            fetch_init: function(e){
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let path = "/api/location/get_delivery_zones/";
                let data = {};
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.zones = response.data.result;
                    }
                    that.zones_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading delivery zones.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.zones_being_loaded = false;
                    return
                }
                this.zones_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            addZone: function(e){
                if (e){
                    e.preventDefault();
                }

                this.zones.push({
                    name: null,
                    id: this.zones.length + 1,
                    items: ""
                });
                return
            },
            deleteZone: function(idx){
                let zone = this.zones[idx];
                let id = zone.id;
                let name = zone.name;

                if (!id || !name){
                    this.zones.splice(idx, 1);
                    return
                }

                let ack = confirm("ARE YOU SURE YOU WANT TO DELETE ZONE: "+name);
                if (!ack){
                    return
                }
                let that = this;
                let path = "/api/location/delete_delivery_zone/"
                let data = {id: id}
                let s =function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Deleted delivery zone", 
                            {title: "Error", autoHideDelay: 1500, variant:"success"}
                        );
                        that.zones.splice(idx, 1);
                    }
                    that.zones_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error deleting delivery zone. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.zones_being_loaded = false;
                    return
                }

                this.zones_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            updateZone: function(idx) {
                let zone = this.zones[idx];
                let name = zone.name;
                let id = zone.id;
                let items = zone.items.split(",");

                items = items.map(function(d){return parseInt(d)}).filter(function(d){return d});
                if (items.length <= 0){
                    this.$bvToast.toast(
                        "Invalid zipcode entries", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                if (!name){
                    this.$bvToast.toast(
                        "Invalid delivery zone name", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                let that = this;
                let path = "/api/location/save_delivery_zone/"
                let data = {name: name, id: id, items: items}
                let s =function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Saved delivery zone", 
                            {title: "Error", autoHideDelay: 1500, variant:"success"}
                        );
                        that.fetch_init();
                    }
                    that.zones_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error saving delivery zone. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.zones_being_loaded = false;
                    return
                }

                this.zones_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                if (this.userDetails.userrole != 'admin'){
                    this.$router.push({path: "/"});
                }
                this.fetch_init();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DeliveryZones.vue